import styled, { css } from 'styled-components';

import { Button, Typography } from '@speeki/global-ui-components';

import {
    Container,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';

import { maxWidth } from '@utils/helpers';

import { breakpoints } from '@shared/constants';

export const SubmittedContainer = styled(Container)`
    height: 100%;
    width: 100%;

    @media (max-width: ${breakpoints.md}px) {
        margin: 0;
        overflow-x: hidden;
        padding: 0;
    }
`;

export const ContainerActions = styled.div`
    display: flex;
    gap: 14px;
    justify-content: center;
    margin-top: 56px;

    @media (max-width: ${breakpoints.md}px) {
        align-items: center;
        flex-direction: column;
    }
`;

export const InfoSection = styled(ContainerSection)`
    max-width: 556px;
    margin: 0;

    ${maxWidth('md')} {
        max-width: unset;
    }
`;

export const ActionButton = styled(Button)`
    max-width: 290px;
    width: 100%;

    @media (max-width: ${breakpoints.md}px) {
        width: 100%;
        max-width: unset;
    }
`;

export const Title = styled(Typography.TextH1_36_52)(
    ({ theme: { font } }) => css`
        font-family: ${font.primary};
        margin-bottom: 32px;
    `,
);

export const Description = styled(Typography.TextBody_16_24)`
    margin-bottom: 40px;
`;

export const CaseIdWrapper = styled.div(
    ({ theme: { palette, radius } }) => css`
        align-items: center;
        background: ${palette.neutral.lightGrey};
        border-radius: ${radius['8']}px;
        display: flex;
        flex-direction: column;
        padding: 20px 32px 32px;

        ${maxWidth('xs')} {
            padding: 24px;
        }
    `,
);

export const CaseIdTitle = styled(Typography.TextBody_16_24)`
    margin-bottom: 12px;
`;

export const Divider = styled.div(
    ({ theme: { palette } }) => css`
        background: ${palette.neutral.dividers};
        height: 1px;
        max-width: 290px;
        width: 100%;
    `,
);

export const CaseId = styled(Typography.TextH1_36_52)(
    ({ theme: { font, fontSize } }) => css`
        font-family: ${font.primary};
        margin-top: 16px;

        ${maxWidth('xs')} {
            font-size: ${fontSize[24]}px;
        }
    `,
);

export const ContainerInner = styled.div`
    display: flex;
    flex-shrink: 0;

    @media (max-width: ${breakpoints.md}px) {
        flex-direction: column-reverse;
    }
`;
